import React from "react";
import {
  Box,
  Collapse,
  Flex,
  Grid,
  GridItem,
  Icon,
  SimpleGrid,
  useDisclosure
} from "@chakra-ui/react";
import { ImMenu3, ImMenu4 } from "react-icons/im";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { FiHelpCircle } from "react-icons/fi";

import { logout } from "utils/auth";
import { ReactComponent as Logo } from "assets/logo.svg";
import PrimaryNav from "components/PrimaryNav";
import NavLink from "components/PrimaryNav/NavLink";

interface SidebarProps {
  isDesktop?: boolean;
}

const SidebarContent: React.FC<SidebarProps> = ({
  isDesktop = false
}: SidebarProps) => {
  return (
    <Grid
      width="100%"
      gap={{
        base: 0,
        md: 12,
        xl: 6
      }}
      pb={8}
      gridTemplateColumns={{
        base: "auto",
        md: "auto 1fr",
        xl: "auto"
      }}
      gridTemplateRows={{
        base: "auto",
        md: "auto 1fr",
        xl: "auto"
      }}
      templateAreas={{
        base: "'nav' 'links'",
        md: "'nav' 'links'",
        xl: "'nav' 'links'"
      }}
    >
      <GridItem gridArea="nav" pt={{ md: 12, xl: 0 }}>
        <PrimaryNav />
      </GridItem>
      <GridItem gridArea="links" hidden={isDesktop}>
        <SimpleGrid columns={2} gap={0}>
          <NavLink
            label="Logout"
            icon={RiLogoutBoxRLine}
            to="/login"
            onClick={logout}
          />
          <NavLink label="Help" icon={FiHelpCircle} to="/help" />
        </SimpleGrid>
      </GridItem>
    </Grid>
  );
};

const Sidebar: React.FC<SidebarProps> = ({
  isDesktop = false
}: SidebarProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex
      direction="column"
      alignItems="center"
      bg="gray.800"
      fontWeight="300"
      fontSize="xl"
      boxShadow="4px 0px 7px -1px rgba(0, 0, 0, 0.25)"
      minHeight={isDesktop ? "100vh" : "unset"}
      height="100%"
      width={isDesktop ? "400px" : "100vw"}
      px={isDesktop ? "48px" : 8}
    >
      {isDesktop ? (
        <>
          <Box w="200px" my={12}>
            <Logo width="100%" />
          </Box>
          <SidebarContent isDesktop={isDesktop} />
        </>
      ) : (
        <>
          <Flex
            p={4}
            direction="row"
            width="100vw"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box w="150px">
              <Logo width="100%" />
            </Box>
            <Box>
              {isOpen ? (
                <Icon as={ImMenu4} onClick={onClose} w={10} h={10} />
              ) : (
                <Icon as={ImMenu3} onClick={onOpen} w={10} h={10} />
              )}
            </Box>
          </Flex>
          <Collapse in={isOpen}>
            <SidebarContent isDesktop={isDesktop} />
          </Collapse>
        </>
      )}
    </Flex>
  );
};

export default Sidebar;
